module.exports = __webpack_public_path__ + "img/concrete-hole-decal-23.97c792bc.png";